import React from 'react';
import { Stack, Typography } from '@mui/material';
import { getSizeFormat } from '@utils/getSizeFormat';
import { useTranslation } from 'react-i18next';
import { StyledLinearProgressBar } from './styles';

interface UploadFileProgressProps {
  size: number;
  uploadedFilesNumber: number;
  filesNumber: number;
  uploadedFilesSize: number;
}

export const UploadFileProgress: React.FC<UploadFileProgressProps> = ({
  size,
  uploadedFilesNumber,
  uploadedFilesSize,
  filesNumber
}) => {
  const { t } = useTranslation();
  const uploadingFileNumber =
    uploadedFilesNumber < filesNumber ? uploadedFilesNumber + 1 : uploadedFilesNumber;
  const progressPercentage = Math.round((uploadedFilesSize / size) * 100);
  return (
    <Stack direction="column" alignItems="center">
      <Stack sx={{ width: '90%', mb: 2 }}>
        <StyledLinearProgressBar
          variant="determinate"
          value={progressPercentage}
          sx={{ height: 6 }}
        />
      </Stack>
      <Stack>
        <Typography color="#808080">
          {t('uploadind-process', {
            uploadingFileNumber,
            filesNumber,
            filesSize: getSizeFormat(size)
          })}
        </Typography>
      </Stack>
    </Stack>
  );
};
